package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_12_15_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-12-15")
@Composable
public fun Log_2023_12_15(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Hexagon Battle Open",
        ogTitle = "Hexagon Battle Open",
        date = LocalDate(2_023, 12, 15),
        ogDescription = "The heroes attend a combat competition where Annette spots a member of the Carnage Crew hiding in the crowd.",
        ogImage = "ai/2023-12-15.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
        Log_2023_12_15_Day_1()
    }
}
